// TranscriptAnalysisRoutine output schemas — mirrors backend
// src/agent/routines/schemas/transcript_analysis.py

export enum ExchangeType {
    ADMISSION = "ADMISSION",
    DENIAL = "DENIAL",
    INCONSISTENCY = "INCONSISTENCY",
    KEY_FACT = "KEY_FACT",
    OBJECTION = "OBJECTION",
    CREDIBILITY = "CREDIBILITY",
    PROCEDURAL = "PROCEDURAL",
}

/** Human-readable labels for ExchangeType values. */
export const ExchangeTypeLabels: Record<ExchangeType, string> = {
    [ExchangeType.ADMISSION]: "Admission",
    [ExchangeType.DENIAL]: "Denial",
    [ExchangeType.INCONSISTENCY]: "Inconsistency",
    [ExchangeType.KEY_FACT]: "Key Fact",
    [ExchangeType.OBJECTION]: "Objection",
    [ExchangeType.CREDIBILITY]: "Credibility",
    [ExchangeType.PROCEDURAL]: "Procedural",
};

/** Tag names as they appear in the database (mirrors backend ExchangeType.tag_names()). */
export const ExchangeTypeTagNames: Record<ExchangeType, string> = {
    [ExchangeType.ADMISSION]: "Admissions",
    [ExchangeType.DENIAL]: "Denials",
    [ExchangeType.INCONSISTENCY]: "Inconsistencies",
    [ExchangeType.KEY_FACT]: "Key Facts",
    [ExchangeType.OBJECTION]: "Objections",
    [ExchangeType.CREDIBILITY]: "Credibility",
    [ExchangeType.PROCEDURAL]: "Procedural",
};

export interface TranscriptExchange {
    speaker: string;
    quote: string;
    exchange_type: ExchangeType;
    significance: string;
    validated?: boolean;
    speaker_tag_id?: string;
}

export interface TranscriptTopic {
    topic_name: string;
    summary: string;
    key_exchanges: TranscriptExchange[];
}

export interface TranscriptBlockAnalysis {
    block_summary: string;
    topics: TranscriptTopic[];
    objections: TranscriptExchange[];
}
